import { render, staticRenderFns } from "./UCTabs.vue?vue&type=template&id=1c17ebd4&scoped=true&"
import script from "./UCTabs.vue?vue&type=script&lang=ts&"
export * from "./UCTabs.vue?vue&type=script&lang=ts&"
import style0 from "./UCTabs.vue?vue&type=style&index=0&id=1c17ebd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c17ebd4",
  null
  
)

export default component.exports